import React from 'react'
import CommonSharedFileDetail from '../../../common/pages/secure/SharedFileDetail'
import Config from '../../../Config'
import PageHeader from '../../components/PageHeader'

class SharedFileDetail extends CommonSharedFileDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyUserApiUrl.systemSettings
    this.apiUrlToDownlaod = Config.companyUserApiUrl.sharedFileDownlaod
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.isShowingEditButton = false
    this.isShowingDeleteButton = false
  }
  renderPageNavi (editButton, deleteButton) {
    return (
      <PageHeader title='事務局からの共有ファイル - 詳細' sub='こちらで事務局からの共有ファイルを確認できます。' history={this.props.history}>
        <ul className='nav nav-pills kw-page-actions'>
          <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
          {editButton}
          {deleteButton}
        </ul>
      </PageHeader>
    )
  }
}

export default SharedFileDetail



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/SharedFileDetail.js